import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import ReactModal from "react-modal";

import { useGetModalSizing } from "./useGetModalSizing";

export const useModalStyle = (
  hasImage: boolean,
  height?: string,
  width?: string,
  contentStyle?: React.CSSProperties,
  noPortal?: boolean,
  overlayStyle?: React.CSSProperties
): ReactModal.Styles => {
  const { isMobile } = useViewport();
  return {
    content: {
      ...useGetModalSizing(hasImage, isMobile, height, width),
      ...(contentStyle ?? {}),
    },
    overlay: {
      ...(noPortal
        ? {
            position: "fixed",
            width: "100vw",
            height: "100vh",
            top: 0,
            left: 0,
          }
        : {}),
      ...(overlayStyle ?? {}),
    },
  };
};
